<template>
  <app-modal-form
    class="release-notes-modal"
    id="release-notes-modal"
    ref="appReleaseNotesModal"
    :okTitle="$t('ok')"
    :showCancelButton="false"
    @submit="onAcceptReleaseNotes"
    @cancel="onAcceptReleaseNotes"
  >
    <template #modal-title>
      <app-icon icon="info-circle-fill"/> <span class="pad-left-half">Volateq Solarinspektor</span>
    </template>
    <p>
      <b>Version: {{ currentWebAppVersion }}</b><br/>
      Browser: {{ getBrowser() }}<br />
      OS: {{ getOS() }}
    </p>
  </app-modal-form>
</template>

<script lang="ts">
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { version } from "../../../package.json";
import { userService } from "../shared/services/user-service/user-service";
import AppModalForm from "@/app/shared/components/app-modal/app-modal-form.vue";
import { IAppModalForm } from "@/app/shared/components/app-modal/types";
import { versionToNumber } from "@/app/shared/services/helper/version-helper";
import { CatchError } from '@/app/shared/services/helper/catch-helper';
import { UsedWebappVersionRequest } from "@/app/shared/services/volateq-api/api-requests/user-requests";
import { BaseAuthOnlineComponent } from "../shared/components/base-auth-component/base-auth-online-component";
import AppIcon from "../shared/components/app-icon/app-icon.vue";

@Component({
  name: "app-release-notes",
  components: {
    AppModalForm,
    AppIcon,
  },
})
export default class AppReleaseNotes extends BaseAuthOnlineComponent {
  @Ref() appReleaseNotesModal!: IAppModalForm;
  @Prop({ default: false }) showReleaseNotes!: boolean;

  currentWebAppVersion: string = version;

  async mounted() {
    await this.updateUserWebAppVersion();
  }

  @CatchError()
  async onAcceptReleaseNotes() {
    const currentWebappVersionRequest: UsedWebappVersionRequest = { used_webapp_version: this.currentWebAppVersion };
    await this.volateqApi.updateWebAppVersion(currentWebappVersionRequest);
    await userService.refreshMe();

    this.appReleaseNotesModal.hide();
  }

  @CatchError()
  @Watch('showReleaseNotes')
  onShowReleaseNotes() {
    if (this.showReleaseNotes) {
      this.appReleaseNotesModal.show();
    }
  }

  async updateUserWebAppVersion() {
    const me = await userService.me();
    
    const lastUsedVersion = versionToNumber(me.profile?.last_used_webapp_version);
    const currentVersion = versionToNumber(this.currentWebAppVersion);

    if (lastUsedVersion < currentVersion) {
      await this.volateqApi.updateWebAppVersion({ used_webapp_version: this.currentWebAppVersion });
      await userService.refreshMe();
    }
  }

  // Stolen from https://stackoverflow.com/posts/5918791
  getBrowser(): string {
    const ua = navigator.userAgent;
    let tem; 
    let match = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(match[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE '+(tem[1] || '');
    }

    if(match[1] === 'Chrome') {
      tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
      if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }

    match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      match.splice(1, 1, tem[1]);
    }

    return match.join(' ');
  }

  getOS() {
    return window.navigator.platform;
  }
}
</script>

<style lang="scss">

#release-notes-modal {
  .modal-content .modal-header {
    padding-bottom: 10px;
  }

  .app-modal-form-title-subtitle {
    font-size: 0.7em;
  }

  .modal-content .modal-body {
    padding-top: 0;
    max-height: 70vh;
    overflow-y: auto;
  }

  .modal-content ul {
    margin: 5px 20px;
  }
}
</style>
